/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// Next runs this file in the browser before any application code.
//
// Unistyles must be configured before the first `StyleSheet.create`. If a
// stylesheet module wins that race on the client, unistyles initialises itself
// from the config the server serialised into `window.__UNISTYLES_STATE__` — JSON
// copies of the themes, i.e. Phoenix tokens without their methods (`toString()`,
// `toRgba()`, `withAlpha()`) and without the lazy `comp` getter — and our real
// `StyleSheet.configure` is then ignored (first initialisation wins).
import { initThemes } from '@airasia-rn/ui/config/unistyles';

initThemes();
